import { useEffect, useState } from 'react';
import { useRouter } from 'next/router';

import { useQuery } from 'react-query';
import { companyInit } from 'services/company';

import UseToast from 'hooks/use-toast';

import CompanyLacking from 'components/pages/company/init/CompanyLacking';
import Spinner from '@core/components/spinner/Spinner';

import { isUserLoggedIn, getAccessToken } from 'utils/authentication';
import { getErrorText } from 'utils/geterrortext';

import { CompanyMembershipStatus } from 'constants/company';

const CompanyInit = () => {
	const [loading, setLoading] = useState(true);
	const router = useRouter();
	const { toast, ToastContainer } = UseToast();
	useEffect(() => {
		if (!isUserLoggedIn()) {
			router.replace('/company/register');
		}
	}, [router.isReady]);

	const { data, refetch } = useQuery(
		['company-profile-init', getAccessToken(), isUserLoggedIn()],
		companyInit.GET,
		{
			onSuccess: (resp) => {
				if (resp.data.company_membership === CompanyMembershipStatus.LACKING) {
					if (
						!resp?.data?.company_invitations ||
						(resp?.data?.company_invitations && resp?.data?.company_invitations?.length === 0)
					) {
						router.replace('/company/new');
					} else {
						setLoading(false);
					}
				} else {
					router.replace('/company/dashboard');
				}
			},
			onError: (error) => {
				if (error.response.status === 428) {
					router.replace('/company/verification');
				} else {
					toast(getErrorText(error), 'Alert');
				}
			},
			enabled: Boolean(isUserLoggedIn()),
			refetchOnMount: 'always'
		}
	);

	return (
		<>
			<ToastContainer />
			{!loading && data ? (
				<CompanyLacking data={data.data} refetch={refetch} />
			) : (
				<div className="d-flex flex-row align-items-center justify-content-center w-100">
					<Spinner />
				</div>
			)}
		</>
	);
};

export default CompanyInit;
